import { defineStore } from 'pinia';
import { DynamicPage } from '@/shared/interfaces/dynamicPage';

export interface NavigationArray {
	key: string;
	value: string;
}

export const useSharedStore = defineStore('shared', {
	state: () => {
		return {
			customNavigation: [] as NavigationArray[],
			shouldUsePayconiq: true,
			shouldUsePreferredPaymentMode: true,
			shouldShowLogin: false,
			onlineEventListeners: [],
			currentSelfOrderingSpotId: '',
			purchaseData: {} as any,
			pendingCheckoutRedirect: '',
			pages: [] as DynamicPage[],
		};
	},
	persist: true,
});
